import React, { useContext, useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Modal, Alert } from 'react-bootstrap';
import { User, Mail, Shield, Calendar, Lock, Edit, LogOut, Save } from 'lucide-react';
import '../../../../assets/css/admin/dashboardCSS/ProfilePage.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import axios from "axios";
import AppContext from "../../../../context/AppContext";

const AdminProfile = () => {
  const { baseUrl, baseUrlForFile, regExpChecker } = useContext(AppContext);
  const [id, setid] = useState();
  const [name, setname] = useState();
  const [email, setemail] = useState();
  const [role, setrole] = useState();
  const [profilePicture, setprofilePicture] = useState();
  const [accountCreated, setaccountCreated] = useState();
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [currentPasswordError, setCurrentPasswordError] = useState("");

  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {

    const admin = JSON.parse(localStorage.getItem("adminData"));

    if (admin) {
      setid(admin.id);
      setname(admin.name);
      setemail(admin.email);
      setrole(admin.isSuperAdmin == 1 ? "Super Admin" : "SubAdmin");
      setprofilePicture(admin.image);
      setaccountCreated(admin.created_at);
    }

  }, []);

  //to save other data than profile picture.
  const saveProfileChanges = () => {

    const formData = new FormData();
    formData.append("id", id);
    formData.append("name", editName);
    formData.append("email", editEmail);

    axios.post(`${baseUrl}/admin/subAdmin/updateSubAdmin`, formData)
      .then((res) => {

        setname(editName);
        setemail(editEmail);

        const updatedAdmin = {
          id: id,
          name: editName,
          email: editEmail,
          image: profilePicture,
          created_at: accountCreated
        };

        localStorage.setItem("adminData", JSON.stringify(updatedAdmin));

        setShowEditModal(false);
        showAlert("Profile updated successfully!");

      })
      .catch((err) => {
        console.log(err);
      });

  };

  //TO update profile picture
  const ProfilePictureUpload = (e) => {
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append("id", id);
    formData.append("file", file);

    axios.post(`${baseUrl}/admin/subAdmin/updateSubAdmin`, formData)
      .then((res) => {
        setprofilePicture(URL.createObjectURL(file));

        showAlert("Profile picture updated!");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const showAlert = (msg) => {
    setAlertMessage(msg);
    setShowSuccessAlert(true);
    setTimeout(() => setShowSuccessAlert(false), 4000);
  };

  /* ── Edit Profile ── */
  const EditProfile = () => {
    setEditName(name);
    setEditEmail(email);
    setShowEditModal(true);
  };


  /* ── Password ── */
  const savePasswordChanges = () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      alert('Please fill all password fields!'); return;
    }
    if (newPassword !== confirmPassword) {
      alert('New passwords do not match!'); return;
    }
    if (newPassword.length < 6) {
      alert('Password must be at least 6 characters!'); return;
    }
    setShowPasswordModal(false);
    showAlert('Password changed successfully!');
  };


  const confirmLogout = () => {
    localStorage.removeItem("adminData");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("adminPassword");
    window.location.href = "/admin-login";
  };

  return (
    <Adminlayout>
      <div className="ap-page">
        <Container fluid>

          {/* Success Alert */}
          {showSuccessAlert && (
            <Alert variant="success" className="ap-success-alert" dismissible onClose={() => setShowSuccessAlert(false)}>
              {alertMessage}
            </Alert>
          )}

          {/* Page Header */}
          <div className="ap-page-header">
            <h2 className="ap-page-title">Admin Profile</h2>
            <p className="ap-page-subtitle">Manage your account settings</p>
          </div>

          <Row className="g-4">

            {/* ── LEFT: Profile Card ── */}
            <Col lg={4}>
              <Card className="ap-profile-card">
                <Card.Body>

                  {/* Avatar */}
                  <div className="ap-avatar-wrap">
                    <img
                      src={profilePicture ? `${baseUrlForFile}/${profilePicture}` : ""}
                      alt="Admin"
                      className="ap-avatar"
                    />
                    <label htmlFor="ap-pic-upload" className="ap-avatar-overlay">
                      <i className="bi bi-camera"></i>
                      <input
                        type="file"
                        id="ap-pic-upload"
                        accept="image/*"
                        onChange={ProfilePictureUpload}
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>

                  {/* Name & Email */}
                  <h3 className="ap-name">{name}</h3>
                  <p className="ap-email">{email}</p>
                  <div className="ap-role-chip">
                    <Shield size={14} />
                    <span>{role}</span>
                  </div>

                  {/* Divider */}
                  <hr className="ap-divider" />

                  {/* Quick Actions */}
                  <h5 className="ap-actions-title">Quick Actions</h5>
                  <div className="ap-actions">
                    <Button className="ap-btn ap-btn-edit" onClick={EditProfile}>
                      <Edit size={16} /> Update Profile
                    </Button>
                    <Button className="ap-btn ap-btn-password" onClick={() => {
                      setCurrentPassword("");
                      setNewPassword("");
                      setConfirmPassword("");
                      setShowPasswordModal(true);
                    }}>
                      <Lock size={16} /> Change Password
                    </Button>
                    <Button className="ap-btn ap-btn-logout" onClick={() => setShowLogoutModal(true)}>
                      <LogOut size={16} /> Logout
                    </Button>
                  </div>

                </Card.Body>
              </Card>
            </Col>

            {/* ── RIGHT: Account Info ── */}
            <Col lg={8}>
              <Card className="ap-info-card">
                <Card.Body>
                  <h4 className="ap-info-title">Account Information</h4>
                  <hr className="ap-divider" />

                  <Row className="g-4 mt-1">
                    <Col md={6}>
                      <div className="ap-info-item">
                        <div className="ap-info-icon"><User size={18} /></div>
                        <div>
                          <p className="ap-info-label">Full Name</p>
                          <p className="ap-info-value">{name}</p>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="ap-info-item">
                        <div className="ap-info-icon"><Mail size={18} /></div>
                        <div>
                          <p className="ap-info-label">Email Address</p>
                          <p className="ap-info-value">{email}</p>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="ap-info-item">
                        <div className="ap-info-icon"><Shield size={18} /></div>
                        <div>
                          <p className="ap-info-label">Role</p>
                          <p className="ap-info-value">{role}</p>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="ap-info-item">
                        <div className="ap-info-icon"><Calendar size={18} /></div>
                        <div>
                          <p className="ap-info-label">Account Created</p>
                          <p className="ap-info-value">
                            {accountCreated ? new Date(accountCreated).toLocaleDateString('en-GB') : ""}
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>

                </Card.Body>
              </Card>
            </Col>

          </Row>
        </Container>

        {/* ════════ EDIT PROFILE MODAL ════════ */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton className="ap-modal-header">
            <Modal.Title><Edit size={20} className="me-2" />Update Profile</Modal.Title>
          </Modal.Header>
          <Modal.Body className="ap-modal-body">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="ap-form-label">Full Name</Form.Label>
                <Form.Control
                  type="text"
                  value={editName}
                  onChange={(e) => {
                    setEditName(e.target.value);
                    setNameError(regExpChecker("username", e.target.value));
                  }}
                  className="ap-form-input"

                />
                <p style={{ color: "red" }}>{nameError}</p>
              </Form.Group>
              <Form.Group>
                <Form.Label className="ap-form-label">Email Address</Form.Label>
                <Form.Control
                  type="email"
                  value={editEmail}
                  onChange={(e) => {
                    setEditEmail(e.target.value);
                    setEmailError(regExpChecker("email", e.target.value));
                  }}

                  className="ap-form-input"
                />
                <p style={{ color: "red" }}>{emailError}</p>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="ap-modal-footer">
            <Button className="ap-modal-cancel" onClick={() => setShowEditModal(false)}>Cancel</Button>
            <Button className="ap-modal-save" onClick={saveProfileChanges}><Save size={16} className="me-2" />Save Changes</Button>
          </Modal.Footer>
        </Modal>

        {/* ════════ CHANGE PASSWORD MODAL ════════ */}
        <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
          <Modal.Header closeButton className="ap-modal-header">
            <Modal.Title><Lock size={20} className="me-2" />Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body className="ap-modal-body">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="ap-form-label">Current Password</Form.Label>
                <Form.Control type="password" placeholder="Enter current password"
                  value={currentPassword}
                  onChange={(e) =>{
                    setCurrentPassword(e.target.value);
                      setCurrentPasswordError(regExpChecker("password", e.target.value));
                  }}
                  className="ap-form-input" />
                    <p style={{ color: "red" }}>{currentPasswordError}</p>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="ap-form-label">New Password</Form.Label>
                <Form.Control type="password" placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setPasswordError(regExpChecker("password", e.target.value));
                  }}
                  className="ap-form-input" />
                <p style={{ color: "red" }}>{passwordError}</p>
                <Form.Text className="text-muted">Minimum 6 characters</Form.Text>
              </Form.Group>
              <Form.Group>
                <Form.Label className="ap-form-label">Confirm New Password</Form.Label>
                <Form.Control type="password" placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setConfirmPasswordError(regExpChecker("confirmPassword", e.target.value, newPassword));
                  }}
                  className="ap-form-input" />
                  <p style={{ color: "red" }}>{confirmPasswordError}</p>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="ap-modal-footer">
            <Button className="ap-modal-cancel" onClick={() => setShowPasswordModal(false)}>Cancel</Button>
            <Button className="ap-modal-save" onClick={savePasswordChanges}><Lock size={16} className="me-2" />Change Password</Button>
          </Modal.Footer>
        </Modal>

        {/* ════════ LOGOUT CONFIRM MODAL ════════ */}
        <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
          <Modal.Header closeButton className="ap-modal-header-danger">
            <Modal.Title><LogOut size={20} className="me-2" />Confirm Logout</Modal.Title>
          </Modal.Header>
          <Modal.Body className="ap-modal-body">
            <p className="mb-0">Are you sure you want to logout from your account?</p>
          </Modal.Body>
          <Modal.Footer className="ap-modal-footer">
            <Button className="ap-modal-cancel" onClick={() => setShowLogoutModal(false)}>Cancel</Button>
            <Button className="ap-modal-logout" onClick={confirmLogout}><LogOut size={16} className="me-2" />Yes, Logout</Button>
          </Modal.Footer>
        </Modal>

      </div>
    </Adminlayout>
  );
};

export default AdminProfile;